import { BlazeLogo } from '@/components/branding/BlazeLogo';
import { useTranslation } from '@/lib/i18n/react';
import { appDownloadLinks, type AppDownloadLinks } from './mobile-access';

const configuredLinks = appDownloadLinks(import.meta.env.VITE_ANDROID_APP_URL, import.meta.env.VITE_IOS_APP_URL);

export function MobileAccessNotice({ links = configuredLinks }: { links?: AppDownloadLinks }) {
  const { t } = useTranslation('shell');
  const downloads = appDownloadLinks(links.android, links.ios);
  // The authenticated panel shows this notice; public widgets use their own route.
  return <main aria-labelledby="mobile-access-title" className="fixed inset-0 z-[2147483647] flex min-h-dvh items-center justify-center overflow-auto bg-paper p-6 text-fg-1">
    <div className="w-full max-w-md space-y-5 text-center">
      <div className="flex items-center justify-center gap-3"><BlazeLogo size={56} decorative /><span className="text-xl font-bold">BlazeTeams</span></div>
      <h1 id="mobile-access-title" className="text-xl font-bold">{t('mobileAccess.title')}</h1>
      <p className="text-sm leading-relaxed text-fg-2">{t('mobileAccess.body')}</p>
      {(downloads.android || downloads.ios) && <div className="flex flex-wrap justify-center gap-3">
        {downloads.android && <a className="inline-flex min-h-11 items-center justify-center rounded-lg bg-blaze-violet px-5 py-3 font-semibold text-white" href={downloads.android} target="_blank" rel="noopener noreferrer">{t('mobileAccess.android')}</a>}
        {downloads.ios && <a className="inline-flex min-h-11 items-center justify-center rounded-lg bg-blaze-violet px-5 py-3 font-semibold text-white" href={downloads.ios} target="_blank" rel="noopener noreferrer">{t('mobileAccess.ios')}</a>}
      </div>}
    </div>
  </main>;
}
